import Hash from 'ipfs-only-hash';
import arrayBufferToBuffer from 'arraybuffer-to-buffer';

export const getIpfsHash = async (file) => {
  const buff = await arrayBufferToBuffer(await file.arrayBuffer());
  const ipfsHash = await Hash.of(buff);
  return ipfsHash;
};
